module.exports = __webpack_public_path__ + "static/media/Big-Sur.3cb1b85f.jpg";